<template>
    <div 
        class="a-m-header-items m-header-items"
        :class="{'m-header-items--white': !color}"
        :style="{'background-color': color}"
    >
        <slot name="left" />
        <span class="m-header-items__wrapper">
            <h3 class="m-header-items__title">
                {{ title }}
            </h3>
            <h4
                v-if="subtitle"
                class="m-header-items__subtitle"
            >
                {{ subtitle }}
            </h4>
        </span>
        <slot 
            v-if="rightSlot"
            name="right"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
    
export default {
    name: 'AMHeaderItems',
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        rightSlot: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
@import "a-m-header-items";   
</style>